import { Component, OnInit } from '@angular/core';
import { PullRequestsService } from '../../services/pull-requests.service';
import { Observable, tap } from 'rxjs';
import { environment } from '@app/environments/environment';

const RELEASE_BRANCH = 'production';

@Component({
    selector: 'toggle-environment',
    templateUrl: './toggle-environment.component.html',
    styleUrls: ['./toggle-environment.component.scss']
})
export class ToggleEnvironmentComponent implements OnInit {
    showToggleEnvironment: boolean;
    subdomain: string;

    placeholderText = environment.build.branch;
    pullRequests$: Observable<string[]>;

    inStudioRelease = false;

    private urls = {
        'sandbox-studio': 'https://sandbox-studio.bannerflow.com',
        'release-studio': 'https://release-studio.bannerflow.com',
        'feature-studio': 'https://feature-studio.bannerflow.com'
    };

    private get allowedUrls(): string[] {
        return Object.keys(this.urls);
    }
    private prBranches: string[] = [];

    constructor(public pullRequestsService: PullRequestsService) {}

    ngOnInit(): void {
        this.subdomain = window.location.hostname.split('.')[0];
        this.checkEnvironment();
        if (!this.showToggleEnvironment) {
            return;
        }
        this.pullRequests$ = this.pullRequestsService.getPullRequests().pipe(
            tap(pullRequests => {
                this.prBranches = pullRequests;
            })
        );
        this.checkReleaseEnv();
    }

    selectPullRequest(pullRequestBranchName: string): void {
        const url = new URL(location.href.replace(origin, this.urls['feature-studio']));
        url.searchParams.set('branch', pullRequestBranchName);
        window.location.href = url.href;
    }

    switchToMaster(): void {
        this.redirectToEnvironment('sandbox-studio');
    }

    switchToRelease(): void {
        this.redirectToEnvironment('feature-studio', RELEASE_BRANCH);
    }

    switchToReleaseSAPI(): void {
        this.redirectToEnvironment('release-studio');
    }

    private redirectToEnvironment(env: keyof typeof this.urls, branch?: string): void {
        const url = new URL(window.location.href.replace(window.location.origin, this.urls[env]));
        url.searchParams.delete('branch');
        if (branch) {
            url.searchParams.set('branch', branch);
        }
        window.location.href = url.href;
    }

    private checkEnvironment(): void {
        this.showToggleEnvironment = this.allowedUrls.includes(this.subdomain);
    }

    private checkReleaseEnv(): void {
        this.inStudioRelease = this.getIsInReleaseBranch();
        if (this.subdomain !== 'release-studio') {
            return;
        }
        this.placeholderText = 'Release studio';
    }

    private getIsInReleaseBranch(): boolean {
        return (
            this.subdomain === 'feature-studio' &&
            (environment.build.branch.startsWith('release') ||
                environment.build.branch.startsWith('production'))
        );
    }
}
